import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    currentUser: null,
    isFetching: false,
    error: false,
  },
  reducers: {
    loginStart: (state) => {
      state.isFetching = true;
    },
    loginSuccess: (state, action) => {
      state.isFetching = false;
      state.currentUser = action.payload;
    },
    loginFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    registerStart: (state) => {
      state.isFetching = true;
    },
    registerSuccess: (state, action) => {
      state.isFetching = false;
      state.currentUser = action.payload;
    },
    registerFailure: (state, action) => {
      // console.log(state, 'state')
      // console.log(action, 'action')
      state.isFetching = false;
      state.error = true;
    },
    resetStart: (state) => {
      state.isFetching = true;
    },
    resetSuccess: (state, action) => {
      state.isFetching = false;
    },
    resetFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    logout(state){
      state.currentUser = null;
      state.isFetching = false;
      state.error = false;
    },
    updateUserStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    updateUserSuccess: (state, action) => {
      state.isFetching = false;
      state.currentUser = action.payload;
    },
    updateUserFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
   
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  registerStart,
  registerSuccess,
  registerFailure,
  resetStart,
  resetSuccess,
  resetFailure,
  logout,
  updateUserStart,
  updateUserSuccess,
  updateUserFailure
} = userSlice.actions;

export default userSlice.reducer;
